import { Box, Button, Flex, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import InfoCircle from '@/assets/icons/info-circle.svg'
import { currentAppEnvConfigs } from '@/configs/env'

import styles from './index.module.css'

interface OnChainTipsProps {
  symbol: string
  isMobile?: boolean
}

export default function OnChainTips({ symbol, isMobile = false }: OnChainTipsProps) {
  const t = useTranslations('tradeWidget')

  const titleKey = 'exploreInOnchain'
  const descriptionKey = 'exploreInOnchainDescription'
  const buttonKey = 'exploreInOnchainButton'

  const content = (
    <Box className={styles.tradingTips}>
      <Flex mb={12}>
        <InfoCircle height={20} fill="var(--common-white)" />
        <Box flex={1} ml={8}>
          <Text variant="body-emphasis" mb={8}>
            {t(titleKey, { symbol })}
          </Text>
          <Text variant="subtitle" c="var(--content-secondary)">
            {t(descriptionKey, { symbol })}
          </Text>
        </Box>
      </Flex>
      <Button
        variant="primary"
        className={styles.onChainButton}
        onClick={() =>
          window.open(`https://${currentAppEnvConfigs.onChainDomain}?source=cdc-price`, '_blank')
        }
      >
        <Text variant="body-emphasis">{t(buttonKey)}</Text>
      </Button>
    </Box>
  )

  return isMobile ? <Box className={styles.responsiveOnChainContainer}>{content}</Box> : content
}
